import React, { FC } from 'react';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';

import { IconName } from '../../assets';
import Icon from '../../assets/Icon';
import { AppAdminLink, RestoAdminLink } from '../../models/Routes';

import './sidebar.scss';

interface Props extends RouteComponentProps {
  link: AppAdminLink | RestoAdminLink;
  text: string;
  icon?: IconName;
}

const SideBarItem: FC<Props & RouteComponentProps> = ({ link, text, icon, location }) => {
  const selected = location.pathname === link;

  return (
    <NavLink to={link} activeClassName='active-link' className='sidebar-link'>
      {icon ? <Icon name={icon + (selected ? 'Selected' : '')} /> : null}
      {text}
    </NavLink>
  );
};

export default withRouter(SideBarItem);
